/**
 * Traductions anglaises. La clé est le texte français d'origine ; une clé absente s'affiche en français.
 * Pour traduire un nouvel écran : envelopper le texte avec `t('Texte français')` (hook `useTranslation`)
 * puis ajouter l'entrée ici.
 */
export default {
    // Menu
    'Tableau de bord': 'Dashboard',
    'Statistiques': 'Statistics',
    'Statistique': 'Statistics',
    'Utilisateurs actifs': 'Active users',
    'Badges utilisateurs': 'User badges',
    'Utilisateurs': 'Users',
    'Pages': 'Pages',
    'Opinions': 'Opinions',
    'Opinions (boostées)': 'Opinions (boosted)',
    'Posts': 'Posts',
    'Posts (boostés)': 'Posts (boosted)',
    'Challenges': 'Challenges',
    'Lives': 'Lives',
    'Evénements': 'Events',
    'Commentaires': 'Comments',
    'Agoras': 'Agoras',
    'Groupes': 'Groups',
    'Reports': 'Reports',
    'Awards': 'Awards',
    'Verifications': 'Verifications',
    'Abonnements': 'Subscriptions',
    'Monétisation': 'Monetization',
    'Liste des portefeuilles': 'Wallets',
    'Liste des comptes monétisés': 'Monetized accounts',
    'Liste des retraits': 'Withdrawals',
    'Ressources humaines': 'Human resources',
    'Soldes de conges': 'Leave balances',
    'Gestion de paiement': 'Payment management',
    "Vue d'ensemble": 'Overview',
    'Pays et frais': 'Countries and fees',
    'Méthodes de paiement': 'Payment methods',
    'Providers': 'Providers',
    'Securité': 'Security',
    'Moderateurs': 'Moderators',
    'Hubs': 'Hubs',
    'Autorisations': 'Authorizations',
    "Demandes d'autorisations": 'Authorization requests',
    "Rapport d'activités": 'Activity log',
    'Paramètres': 'Settings',
    'Mon profil': 'My profile',
    'Déconnexion': 'Log out',
    'Langue': 'Language',

    // Authentification
    'Espace moderateur': 'Moderator area',
    'Adresse email': 'Email address',
    'Mot de passe': 'Password',
    'Me connecter': 'Log in',
    'Connexion en cour...': 'Logging in...',
    'Mot de passe oublié ?': 'Forgot your password?',
    'Authentification réussie !': 'Login successful!',
    'Champ obligatoire': 'Required field',
    'Le mot de passe doit etre au minimun 6 caracteres': 'The password must be at least 6 characters long',
    'Oups': 'Oops',
    'Entrez votre adresse email pour réinitialiser votre mot de passe.': 'Enter your email address to reset your password.',
    'Mot de passe réinitialisé, merci de consulter vos courriels !': 'Password reset, please check your emails!',
    'Retour à la page de': 'Back to the',
    'connexion': 'login page',
    'Page introuvable': 'Page not found',
    'La page que vous recherchez est introuvable, veuillez contactez les administrateurs systemes': 'The page you are looking for cannot be found, please contact the system administrators',
    'Retour': 'Back',

    // Composants partagés
    'Annuler': 'Cancel',
    'Page': 'Page',
    'Précédent': 'Previous',
    'Suivant': 'Next',
    'Rechercher': 'Search',
    'Enregistrer': 'Save',
    'Enregistrement...': 'Saving...',
    'Modifier': 'Edit',
    'Oui': 'Yes',
    'Non': 'No',
    'Activé': 'Enabled',
    'Désactivé': 'Disabled',
    'activé': 'enabled',
    'désactivé': 'disabled',
    'Ouvert': 'Open',
    'Épuisé': 'Exhausted',
    'Illimité': 'Unlimited',
    'Total': 'Total',
    'Code': 'Code',
    'État': 'Status',
    'Erreur de traitement, veuillez contacter les administrateurs': 'Processing error, please contact the administrators',

    // Utilisateurs
    'Filtre de recherche': 'Search filter',
    'Identifiant': 'ID',
    "Nom d'utilisateur": 'Username',
    'Nom': 'Last name',
    'Prénom': 'First name',
    'Parrainage : tous les utilisateurs': 'Referral: all users',
    'Avec une exception de parrainage': 'With a referral exception',
    'Parrainage forcé activé': 'Referral forced on',
    'Parrainage forcé désactivé': 'Referral forced off',
    'Offrir un abonnement': 'Give a subscription',
    'Offrir des coins': 'Give coins',
    'Restreindre': 'Restrict',
    'Lever la restriction': 'Lift the restriction',
    'Mute': 'Mute',
    'Unmute': 'Unmute',
    'Mute utilisateur': 'Mute user',
    "Restriction de l'utilisateur": 'User restriction',
    "Restreindre jusqu'au ?": 'Restrict until?',
    "Invisible jusqu'au ?": 'Hidden until?',
    'Bloquer la création de contenu spécial': 'Block special content creation',
    'Autoriser la création de contenu spécial': 'Allow special content creation',
    'Profil': 'Profile',
    'Verified': 'Verified',
    'Premium / Gold': 'Premium / Gold',
    "Type d'abonnement": 'Subscription type',
    "Durée de l'abonnement": 'Subscription duration',
    "Selectionnez le type d'abonnement": 'Select the subscription type',
    "Selectionnez la durée de l'abonnement": 'Select the subscription duration',
    'Abonnement gratuit': 'Free subscription',
    'Nombre de coin': 'Number of coins',
    'Définissez le nombre de coin': 'Set the number of coins',

    // Paramètres
    'Paramètre': 'Setting',
    'Version iOS': 'iOS version',
    'Version Android': 'Android version',
    'Version Huawei': 'Huawei version',
    'Pagination des opinions': 'Opinions pagination',
    'Pagination des commentaires': 'Comments pagination',
    'Lien média': 'Media link',
    'Lien youtube': 'YouTube link',
    'For You': 'For You',
    "Activer 'For-You' ?": "Enable 'For-You'?",
    'Base API': 'API base',
    'Fallback Base API': 'Fallback API base',
    'Google Translate API Key': 'Google Translate API key',
    'Service Cashout': 'Cashout service',
    'Activer le service cashout ?': 'Enable the cashout service?',
    'Coin Exchange (USD)': 'Coin Exchange (USD)',
    'Like Exchange (USD)': 'Like Exchange (USD)',
    'View Exchange (USD)': 'View Exchange (USD)',
    'Cashout Minimum (USD)': 'Cashout minimum (USD)',
    'Cashout Fees (XOF)': 'Cashout fees (XOF)',
    'Exchange Rate USD to XOF': 'Exchange rate USD to XOF',
    'Exchange Fees (%)': 'Exchange fees (%)',
    'Minimum Followers (Contenu Spécial)': 'Minimum followers (special content)',
    'Pourcentage Créateur (Contenu Spécial)': 'Creator percentage (special content)',
    'Récompense Top Comment': 'Top Comment reward',
    'Récompense Top Suggestion': 'Top Suggestion reward',
    'Sélectionner une récompense': 'Select a reward',
    'Header logo': 'Header logo',
    'Fichier Header Logo': 'Header logo file',
    'Mise a jour des paramètres': 'Update settings',

    // Parrainage
    "Suivi des parrainages": "Referral tracking",
    "Parrainages": "Referrals",
    "Récompensés": "Rewarded",
    "Récompensé": "Rewarded",
    "Versé (USD)": "Paid out (USD)",
    "Meilleurs parrains": "Top referrers",
    "Motifs de rejet": "Rejection reasons",
    "Aucun rejet.": "No rejections.",
    "Rechercher : parrain, filleul ou code": "Search: referrer, referred user or code",
    "Parrain": "Referrer",
    "Filleul": "Referred user",
    "Gain parrain": "Referrer reward",
    "Gain filleul": "Referred reward",
    "Aucun parrainage ne correspond aux filtres.": "No referral matches the filters.",
    "Le système de parrainage n'est pas encore déployé.": "The referral system is not deployed yet.",
    "Aujourd'hui : {{n}}": "Today: {{n}}",
    "Conversion : {{p}} %": "Conversion: {{p}}%",
    "Rejetés : {{n}}": "Rejected: {{n}}",
    "Parrains {{a}} · filleuls {{b}}": "Referrers {{a}} · referred {{b}}",
    "{{n}} filleuls": "{{n}} referred",
    "Expire le {{d}}": "Expires {{d}}",
    'Parrainage': 'Referral',
    'Parrainage activé': 'Referral enabled',
    'Activer le parrainage ?': 'Enable referrals?',
    "Bonus d'inscription du filleul": 'Referred user signup bonus',
    "Bonus d'inscription du filleul (USD)": 'Referred user signup bonus (USD)',
    'Bonus du parrain': 'Referrer bonus',
    'Bonus du parrain (USD)': 'Referrer bonus (USD)',
    'Plafond de filleuls récompensés par parrain': 'Cap on rewarded referrals per referrer',
    'Budget de parrainage': 'Referral budget',
    'Budget de parrainage (USD, 0 = aucun versement)': 'Referral budget (USD, 0 = no payout)',
    'Non défini : aucun versement tant que le budget est à 0': 'Not set: no payout while the budget is 0',
    'Période du budget': 'Budget period',
    'Par jour': 'Per day',
    'Par mois': 'Per month',
    'Total (sans renouvellement)': 'Total (no renewal)',
    'Mode du budget': 'Budget mode',
    "Réservation : le coût est réservé à l'inscription": 'Reservation: the cost is reserved at signup',
    'Sans réservation : bonus perdu si le budget est épuisé à la vérification': 'No reservation: bonus lost if the budget is exhausted at verification',
    "Réservation à l'inscription": 'Reservation at signup',
    'Sans réservation': 'No reservation',
    "Expiration d'un parrainage en attente": 'Pending referral expiry',
    "Expiration d'un parrainage en attente (jours, mode réservation)": 'Pending referral expiry (days, reservation mode)',
    'E-mails des alertes de parrainage': 'Referral alert emails',
    'E-mails des alertes de parrainage (séparés par des virgules ; vide = SERVICE_ALERT_EMAILS)': 'Referral alert emails (comma-separated; empty = SERVICE_ALERT_EMAILS)',
    'Comptes recevant les alertes push': 'Accounts receiving push alerts',
    'Comptes recevant les alertes push (user_id ou username, séparés par des virgules)': 'Accounts receiving push alerts (user_id or username, comma-separated)',
    'KYC exigé': 'KYC required',
    'Exiger le KYC du parrain pour obtenir un code de parrainage': 'Require the referrer KYC to get a referral code',
    'Exiger le KYC pour les retraits': 'Require KYC for withdrawals',
    'Exiger le KYC pour ajouter / modifier un portefeuille de retrait': 'Require KYC to add / edit a withdrawal wallet',
    'Bloquer les e-mails jetables (parrainage)': 'Block disposable emails (referral)',
    "Pas de bonus pour les e-mails jetables (l'inscription reste possible)": 'No bonus for disposable emails (signup remains possible)',
    "Les bonus sont versés après la vérification de l'e-mail du filleul. Les montants sont en USD et convertis en coins avec le « Coin Exchange » ci-dessus.": "Bonuses are paid after the referred user's email is verified. Amounts are in USD and converted to coins with the \"Coin Exchange\" above.",
    'Indisponible : mise à jour de la base de données en attente': 'Unavailable: database update pending',
    'Entier entre 1 et 365': 'Integer between 1 and 365',
    'Entier supérieur ou égal à 1, ou cochez « Illimité »': 'Integer greater than or equal to 1, or tick "Unlimited"',
    'Montant invalide (0 = aucun versement)': 'Invalid amount (0 = no payout)',
    'Montant invalide (entre 0 et 100)': 'Invalid amount (between 0 and 100)',
    'Adresse e-mail invalide': 'Invalid email address',
    'Suivre le réglage global': 'Follow the global setting',
    'Activé (même si le global est coupé)': 'Enabled (even if the global setting is off)',
    'exception individuelle ; réglage global': 'individual exception; global setting',
    'Filleuls récompensés': 'Rewarded referrals',
    'Gains de parrainage': 'Referral earnings',
    'en attente': 'pending',
    'Enregistrement impossible.': 'Could not save.',
    'Consommé': 'Spent',
    'réservé': 'reserved',
    'restant': 'remaining',
    'sur': 'of',
    "coût d'un parrainage": 'cost of one referral',
    'perdus (budget / expiration)': 'lost (budget / expiry)',
    'Le budget est de nouveau suffisant.': 'The budget is sufficient again.',
    'Annoncer la réouverture du parrainage :': 'Announce that referrals have reopened:',
    'Annoncer la réouverture': 'Announce reopening',
    'Parrains et parrainages en attente': 'Referrers and pending referrals',
    'Tous les utilisateurs actifs': 'All active users',
    "Texte fixe, envoyé dans la langue de chaque utilisateur (anglais par défaut).": 'Fixed text, sent in each user\'s language (English by default).',
    "Envoyer l'annonce à TOUS les utilisateurs actifs ({{count}} destinataires) ?": 'Send the announcement to ALL active users ({{count}} recipients)?',
    "Annonce mise en file : l'envoi démarre dans quelques minutes.": 'Announcement queued: sending starts in a few minutes.',
    "Impossible de mettre l'annonce en file.": 'Could not queue the announcement.',
    "Le budget n'a pas été épuisé : pas d'annonce nécessaire.": 'The budget was not exhausted: no announcement needed.',
    'Le budget est encore épuisé : augmentez-le ou attendez la prochaine période.': 'The budget is still exhausted: increase it or wait for the next period.',
    'La réouverture a déjà été annoncée.': 'The reopening has already been announced.',
    'Une annonce a déjà été mise en file depuis moins de 24 h.': 'An announcement was already queued less than 24 hours ago.',
    'Annonce indisponible : mise à jour de la base de données en attente.': 'Announcement unavailable: database update pending.',

    // Autres écrans (paiements, vérifications, autorisations, statistiques, etc.)
    "#Recherche...": "#Search...",
    "Abonnements Gold & Premium en cours": "Active Gold & Premium subscriptions",
    "Accueil": "Home",
    "Accès non autorisé !": "Access denied!",
    "Actif": "Active",
    "Inactif": "Inactive",
    "Activer des méthodes": "Enable methods",
    "Activez des méthodes et définissez les frais dans la configuration par pays pour qu’elles apparaissent ici.": "Enable methods and set the fees in the per-country configuration for them to appear here.",
    "Administrateur": "Administrator",
    "Administrateur ?": "Administrator?",
    "Administrateur / Moderateur": "Administrator / Moderator",
    "Adminsitrateur": "Administrator",
    "Adresse IP": "IP address",
    "Adresse email 1": "Email address 1",
    "Adresse email 2": "Email address 2",
    "Adresse email 3": "Email address 3",
    "Adresses emails autorisées": "Authorized email addresses",
    "Afficher": "Show",
    "Agence": "Agency",
    "Aller à la page cashout": "Go to the cashout page",
    "Approuvé": "Approved",
    "Aucun canal. Ajoutez-en un pour les associer aux frais.": "No channel. Add one to link them to fees.",
    "Aucun compte associe": "No linked account",
    "Aucun compte monétisé trouvé.": "No monetized account found.",
    "Aucun frais. Cliquez sur « Nouveau frais » pour en ajouter un.": "No fee. Click \"New fee\" to add one.",
    "Aucun live en cours": "No live in progress",
    "Aucun provider. Cliquez sur « Nouveau provider ».": "No provider. Click \"New provider\".",
    "Aucun resultat": "No result",
    "Aucun utilisateur trouvé.": "No user found.",
    "Aucun utilisateur à afficher.": "No user to display.",
    "Aucune méthode dans le catalogue.": "No method in the catalog.",
    "Aucune méthode pour l’instant": "No method yet",
    "Aujourd'hui": "Today",
    "Autres indicateurs": "Other indicators",
    "Bénéficiaire": "Beneficiary",
    "Canal": "Channel",
    "Canal :": "Channel:",
    "Canal actif": "Active channel",
    "Canaux de la méthode": "Method channels",
    "Cashout utilisateur": "User cashout",
    "Catalogue": "Catalog",
    "Catalogue des méthodes": "Methods catalog",
    "Catalogue pour ce pays": "Catalog for this country",
    "Cause du rejet": "Rejection reason",
    "Ce mois": "This month",
    "Cette année": "This year",
    "Cette semaine": "This week",
    "Ce pays de paiement n’existe pas ou n’est plus actif.": "This payment country does not exist or is no longer active.",
    "Cette action est irreversible, confirmer ?": "This action is irreversible, confirm?",
    "Changement du mot de passe effectué, vous allez être deconnecté.": "Password changed, you will be logged out.",
    "Chargement des nouveaux utilisateurs…": "Loading new users…",
    "Chargement des utilisateurs actifs…": "Loading active users…",
    "Cochez les méthodes offertes sur ce marché. Les cases modifient la liaison pays ↔ méthode pour chaque méthode du catalogue.": "Tick the methods offered in this market. The boxes change the country ↔ method link for each catalog method.",
    "Code banque": "Bank code",
    "Commentaire supprimé": "Comment deleted",
    "Compte": "Account",
    "Compte bénéficiaire": "Beneficiary account",
    "Compte certifie": "Verified account",
    "Compte certifié": "Verified account",
    "Compte crédité": "Credited account",
    "Compte officiel MyOpinion": "Official MyOpinion account",
    "Compte premium": "Premium account",
    "Configuration API (JSON optionnel)": "API configuration (optional JSON)",
    "Configuration des paiements": "Payment configuration",
    "Configurer / frais": "Configure / fees",
    "Confirmation du mot de passe": "Password confirmation",
    "Confirmation du nouveau mot de passe": "New password confirmation",
    "Confirmation requise avant suppression définitive": "Confirmation required before permanent deletion",
    "Confirmer ?": "Confirm?",
    "Confirmer l'arrêt du live ?": "Confirm ending the live?",
    "Confirmer suppression du compte ?": "Confirm account deletion?",
    "Date actualisation": "Update date",
    "Date d'actualisation des soldes": "Balance update date",
    "Date d'expiration": "Expiry date",
    "Date de début": "Start date",
    "Date de naissance": "Date of birth",
    "Date de soumission": "Submission date",
    "Date de traitement": "Processing date",
    "Debut période": "Period start",
    "Fin période": "Period end",
    "Dernière activité": "Last activity",
    "Dernière mise à jour": "Last update",
    "Deverouillé": "Unlocked",
    "Verrouillé": "Locked",
    "Devise": "Currency",
    "Devise :": "Currency:",
    "Devise utilisée pour les paiements sur ce marché": "Currency used for payments in this market",
    "Disponibilité des méthodes enregistrée.": "Method availability saved.",
    "Disponibilité par pays": "Availability by country",
    "Disponible pour ce pays": "Available for this country",
    "Document recto": "Document front",
    "Document verso": "Document back",
    "Drapeau": "Flag",
    "Durée": "Duration",
    "Détail du paiement": "Payment detail",
    "Détails du paiement": "Payment details",
    "EX: FLUTTERWAVE": "E.g. FLUTTERWAVE",
    "En attente": "Pending",
    "En base, les enregistrements liés (frais, canaux provider) peuvent être supprimés en cascade selon la configuration SQL.": "In the database, linked records (fees, provider channels) may be deleted in cascade depending on the SQL configuration.",
    "Enregistrer les changements": "Save changes",
    "Erreur de chargement": "Loading error",
    "Erreur de traitement": "Processing error",
    "Erreur lors de la mise à jour du statut": "Error while updating the status",
    "Es-tu sûr de vouloir mettre à jour le statut de cette transaction ?": "Are you sure you want to update the status of this transaction?",
    "Evénement à venir": "Upcoming event",
    "Expliquez la cause du rejet...": "Explain the reason for rejection...",
    "Fixe": "Fixed",
    "Montant fixe": "Fixed amount",
    "Flux / type de frais :": "Flow / fee type:",
    "Fonction": "Position",
    "Frais": "Fees",
    "Frais — méthode de paiement": "Fees — payment method",
    "Gestion des méthodes": "Methods management",
    "Gratuit": "Free",
    "Historique de commentaires": "Comments history",
    "Identifiant du compte": "Account ID",
    "Importation de fichier d'autorisation": "Authorization file import",
    "Importation du fichier d'actualisation des soldes de conges": "Leave balance update file import",
    "Importer le fichier d'intégration des soldes": "Import the balance integration file",
    "Importer un fichier d'autorisation": "Import an authorization file",
    "Impossible de charger ces statistiques.": "Unable to load these statistics.",
    "Impossible de charger les méthodes de paiement pour ce pays.": "Unable to load the payment methods for this country.",
    "Inscription": "Registration",
    "Introuvable": "Not found",
    "La configuration n’a pas pu être chargée pour ce pays.": "The configuration could not be loaded for this country.",
    "Les frais et liaisons canaux associés peuvent être impactés": "Associated fees and channel links may be affected",
    "Lien pays ↔ méthode actif dans la configuration": "Country ↔ method link active in the configuration",
    "Liste de méthode de paiement": "Payment methods list",
    "Liste des paiements": "Payments list",
    "Liste des pays": "Countries list",
    "Liste des pays de paiement": "Payment countries list",
    "Liste des transactions": "Transactions list",
    "Lives encours": "Lives in progress",
    "Logo (chemin / URL stockage, optionnel)": "Logo (path / storage URL, optional)",
    "Logo (chemin, optionnel)": "Logo (path, optional)",
    "Matricule": "Employee ID",
    "Membre": "Member",
    "Membre depuis le": "Member since",
    "Membres": "Members",
    "Minimun 6 carateres": "Minimum 6 characters",
    "Mise a jour du Hub distant": "Remote Hub update",
    "Mise a jour du profile effectuée !": "Profile updated!",
    "Mise à jour du solde de conges": "Leave balance update",
    "Mise à jour du solde du compte MyOpinion": "MyOpinion account balance update",
    "Modérateur": "Moderator",
    "Modérateurs": "Moderators",
    "Monnaie": "Currency",
    "Monnaie locale": "Local currency",
    "Montant": "Amount",
    "Montant (USD)": "Amount (USD)",
    "Monétisation - Cashout": "Monetization - Cashout",
    "Mot cle": "Keyword",
    "Mot clé": "Keyword",
    "Motif de rejet": "Rejection reason",
    "Méthode": "Method",
    "Méthode de paiement": "Payment method",
    "Méthodes": "Methods",
    "Méthodes actives pour ce marché": "Active methods for this market",
    "Méthodes activées": "Enabled methods",
    "Méthodes effectivement proposées aux utilisateurs de ce pays": "Methods actually offered to users in this country",
    "Méthodes listées": "Listed methods",
    "Méthodes visibles sur cette page pour le pays sélectionné": "Methods visible on this page for the selected country",
    "No. compte": "Account no.",
    "Nom affiché": "Display name",
    "Nom complet": "Full name",
    "Nom du canal": "Channel name",
    "Nouveau hub distant": "New remote hub",
    "Nouveau modérateur": "New moderator",
    "Nouveau mot de passe": "New password",
    "Nouveau provider": "New provider",
    "Nouvelle autorisation (Saisie)": "New authorization (entry)",
    "Numero de la pièce": "Document number",
    "Numéro": "Number",
    "Operation effectuée !": "Operation completed!",
    "Paramètres de paiement": "Payment settings",
    "Partages": "Shares",
    "Pays": "Country",
    "Pays :": "Country:",
    "Pays:": "Country:",
    "Pays de paiement": "Payment country",
    "Pays introuvable": "Country not found",
    "Plafond": "Cap",
    "Plateforme": "Platform",
    "Potes": "Buddies",
    "Pourcentage (%)": "Percentage (%)",
    "Priorité": "Priority",
    "Prix (USD)": "Price (USD)",
    "Profile modérateur": "Moderator profile",
    "Provider :": "Provider:",
    "Providers de paiement": "Payment providers",
    "Période": "Period",
    "Périodes": "Periods",
    "Raisons:": "Reasons:",
    "Rechercher (nom ou code)...": "Search (name or code)...",
    "Rechercher un utilisateur...": "Search for a user...",
    "Refuser la vérification": "Reject the verification",
    "Refusée": "Rejected",
    "Rejeté": "Rejected",
    "Reponses": "Replies",
    "Restaurer l'autorisation": "Restore the authorization",
    "Resumés des activités": "Activity summaries",
    "Retour à la liste": "Back to the list",
    "Retour à la liste des pays": "Back to the countries list",
    "Règle d’affichage": "Display rule",
    "Réactions:": "Reactions:",
    "Récapitulatif": "Summary",
    "Référence": "Reference",
    "Référentiel des partenaires techniques (routing, frais, canaux).": "Technical partners reference (routing, fees, channels).",
    "Réinitialiser": "Reset",
    "Saisie de nouvelles autorisation": "New authorizations entry",
    "Selectionnez le fichier a importer": "Select the file to import",
    "Selectionnez le pays": "Select the country",
    "Selectionnez le type de pièce": "Select the document type",
    "Signalement": "Report",
    "Signalé le:": "Reported on:",
    "Solde": "Balance",
    "Solde de MyOpinion (COIN)": "MyOpinion balance (COIN)",
    "Solde de congés (jours)": "Leave balance (days)",
    "Soldes de congés du personnel": "Staff leave balances",
    "Soutiens": "Support",
    "Statistiques utilisateurs (Actifs)": "User statistics (Active)",
    "Statistiques utilisateurs (Badges)": "User statistics (Badges)",
    "Statut": "Status",
    "Statut:": "Status:",
    "Statut de la demande": "Request status",
    "Statut du profil": "Profile status",
    "Statut mis à jour avec succès": "Status updated successfully",
    "Succès": "Success",
    "Super administrateur": "Super administrator",
    "Suppression du frais": "Fee deletion",
    "Suppression du provider": "Provider deletion",
    "Supprimer": "Delete",
    "Supprimer la méthode ?": "Delete the method?",
    "Supprimer le boost \nConfirmer ?": "Delete the boost\nConfirm?",
    "Supprimer le compte": "Delete the account",
    "Tag technique (unique)": "Technical tag (unique)",
    "Titre": "Title",
    "Top des comptes monétisés": "Top monetized accounts",
    "Total de coins encaissés": "Total coins cashed out",
    "Total de coins à payer": "Total coins to pay",
    "Total de likes encaissés": "Total likes cashed out",
    "Total de likes à payer": "Total likes to pay",
    "Total de vues encaissés": "Total views cashed out",
    "Total de vues à payer": "Total views to pay",
    "Transaction introuvable.": "Transaction not found.",
    "Type d'award": "Award type",
    "Type de frais": "Fee type",
    "Type de piece": "Document type",
    "Type de pièce": "Document type",
    "Type de section": "Section type",
    "Type paiement": "Payment type",
    "Téléphone": "Phone",
    "Une ligne = une méthode ; la case « Actif » l’associe au pays.": "One row = one method; the \"Active\" box links it to the country.",
    "Utilisateur": "User",
    "Utilisateur / Personnel RH": "User / HR staff",
    "Validation la vérification": "Verification approval",
    "Valider la vérification": "Approve the verification",
    "Validée": "Approved",
    "Veuillez préciser la raison du rejet.": "Please specify the reason for rejection.",
    "Veuillez selectionner au moins un motif": "Please select at least one reason",
    "Ville:": "City:",
    "Voir le profil": "View profile",
    "Vous n'avez pas accès a cette ressource": "You do not have access to this resource",
    "Vues": "Views",
    "Vues (USD)": "Views (USD)",
    "Vérifications des profils utilisateurs": "User profile verifications",
    "Wallet mis à jour avec succès": "Wallet updated successfully",
    "irréversible": "irreversible",
    "supprimer définitivement": "delete permanently",
    "Échoué": "Failed",
    "Êtes-vous sur ? \nRefuser autorisation ": "Are you sure?\nReject authorization ",
    "Êtes-vous sur ? \nSupprimer ": "Are you sure?\nDelete ",
    "Êtes-vous sur ? \nValider autorisation ": "Are you sure?\nApprove authorization ",
    "Êtes-vous sûr de vouloir rendre cet utilisateur à nouveau visible ?": "Are you sure you want to make this user visible again?",
    "— Pays —": "— Country —",
    "— Tous canaux —": "— All channels —",

    // Messages d'erreur, états de chargement, libellés calculés
    "Action non autorisée.": "Action not allowed.",
    "Activer le mode stats": "Enable stats mode",
    "Désactiver le mode stats": "Disable stats mode",
    "Aucune description": "No description",
    "Canal créé.": "Channel created.",
    "Canal mis à jour.": "Channel updated.",
    "Cashout créé avec succès.": "Cashout created successfully.",
    "Catalogue des méthodes : support payin/payout, plateformes, pays associés, canaux et liaisons provider.": "Methods catalog: payin/payout support, platforms, linked countries, channels and provider links.",
    "Chargement des données...": "Loading data...",
    "Chargement des indicateurs de paiement...": "Loading payment indicators...",
    "Chargement des méthodes...": "Loading methods...",
    "Chargement du compte officiel MyOpinion...": "Loading the official MyOpinion account...",
    "Chargement du top des comptes monétisés...": "Loading the top monetized accounts...",
    "Chargement du top utilisateurs par coins...": "Loading the top users by coins...",
    "Chargement du top utilisateurs par likes...": "Loading the top users by likes...",
    "Chargement du top utilisateurs par vues...": "Loading the top users by views...",
    "Chargement…": "Loading…",
    "Coins, likes et vues": "Coins, likes and views",
    "Configuration API : JSON invalide (ou laissez vide).": "API configuration: invalid JSON (or leave empty).",
    "Configurer la méthode": "Configure the method",
    "Confirmer activation du compte ?": "Confirm account activation?",
    "Confirmer désactivation du compte ?": "Confirm account deactivation?",
    "Connexion impossible. Vérifiez votre réseau.": "Unable to connect. Check your network.",
    "Contacts & Abonnés": "Contacts & Subscribers",
    "Potes & Fans": "Buddies & Fans",
    "Cote d'Ivoire": "Ivory Coast",
    "Date de fin": "End date",
    "Données invalides, veuillez vérifier le formulaire.": "Invalid data, please check the form.",
    "Données invalides.": "Invalid data.",
    "Décaissement": "Payout",
    "Encaissement": "Payin",
    "Encaissement & décaissement": "Payin & payout",
    "Toutes plateformes": "All platforms",
    "Erreur chargement méthodes du pays :": "Error loading the country methods:",
    "Erreur lors de l’enregistrement. Vérifiez la console ou les frais configurés.": "Error while saving. Check the console or the configured fees.",
    "Erreur lors du cashout.": "Cashout error.",
    "Erreur lors du cashout. Veuillez vérifier les informations ou réessayer.": "Cashout error. Please check the information or try again.",
    "Erreur serveur. Réessayez plus tard.": "Server error. Try again later.",
    "Es-tu sûr de vouloir mettre à jour le statut de ce portefeuille ?": "Are you sure you want to update the status of this wallet?",
    "Exporter la liste": "Export the list",
    "Format email invalide": "Invalid email format",
    "Format incorrecte": "Invalid format",
    "Frais créé.": "Fee created.",
    "Frais mis à jour.": "Fee updated.",
    "Frais supprimé.": "Fee deleted.",
    "Gérer les pays": "Manage countries",
    "Gérer les providers": "Manage providers",
    "Voir les méthodes": "View methods",
    "Impossible de charger la liste des méthodes pour ce pays.": "Unable to load the methods list for this country.",
    "Impossible de charger les statistiques pour le moment.": "Unable to load the statistics at the moment.",
    "Impossible de contacter le serveur. Vérifiez votre connexion et réessayez.": "Unable to reach the server. Check your connection and try again.",
    "Indiquez un montant fixe supérieur à 0.": "Enter a fixed amount greater than 0.",
    "Indiquez un pourcentage supérieur à 0.": "Enter a percentage greater than 0.",
    "La devise du pays est introuvable ou invalide.": "The country currency was not found or is invalid.",
    "Le montant fixe doit être supérieur à 0.": "The fixed amount must be greater than 0.",
    "Le montant maximum doit être supérieur ou égal au minimum.": "The maximum amount must be greater than or equal to the minimum.",
    "Le montant maximum est obligatoire (> 0).": "The maximum amount is required (> 0).",
    "Le montant minimum est obligatoire (≥ 0).": "The minimum amount is required (≥ 0).",
    "Le montant minimum ne peut pas dépasser le maximum.": "The minimum amount cannot exceed the maximum.",
    "Le mot de passe ne correspond pas": "The password does not match",
    "Le nom du provider est obligatoire.": "The provider name is required.",
    "Le pays est obligatoire.": "The country is required.",
    "Le plafond doit être supérieur à 0.": "The cap must be greater than 0.",
    "Le pourcentage doit être supérieur à 0.": "The percentage must be greater than 0.",
    "Le provider est obligatoire.": "The provider is required.",
    "Le tag (référence technique) est obligatoire.": "The tag (technical reference) is required.",
    "Liste des pays et activation des méthodes par marché (cocher / décocher).": "Countries list and method activation per market (tick / untick).",
    "Liste frais dédiée indisponible, repli sur la méthode :": "Dedicated fees list unavailable, falling back to the method:",
    "Mettre à jour": "Update",
    "Mise à jour...": "Updating...",
    "Modifier ce canal": "Edit this channel",
    "Modifier ce frais": "Edit this fee",
    "Modifier ce provider": "Edit this provider",
    "Modifier le canal": "Edit the channel",
    "Modifier le frais": "Edit the fee",
    "Modifier le provider": "Edit the provider",
    "Méthode de paiement introuvable.": "Payment method not found.",
    "Méthodes pour ce pays": "Methods for this country",
    "Nom et tag du canal sont obligatoires.": "Channel name and tag are required.",
    "Nouveau canal": "New channel",
    "Nouveau frais": "New fee",
    "Objectif de vie": "Life goal",
    "Options frais indisponibles, repli sur les pays de la méthode :": "Fee options unavailable, falling back to the method countries:",
    "Partenaires techniques de paiement : priorité, statut, configuration API et suppression.": "Technical payment partners: priority, status, API configuration and deletion.",
    "Ressource introuvable.": "Resource not found.",
    "SERVICE_ALERT_EMAILS (par défaut)": "SERVICE_ALERT_EMAILS (default)",
    "Selectionnez un date": "Select a date",
    "Suppression impossible.": "Unable to delete.",
    "Supprimer ce frais": "Delete this fee",
    "Supprimer ce provider": "Delete this provider",
    "Supprimer la méthode": "Delete the method",
    "Sélectionner une méthode": "Select a method",
    "Top 10 pays avec le plus d'utilisateurs actifs": "Top 10 countries with the most active users",
    "Top 10 utilisateurs": "Top 10 users",
    "Top commentaire": "Top comment",
    "Téléchargement...": "Downloading...",
    "Télécharger le modele d'importation": "Download the import template",
    "Télécharger le modèle d'importation": "Download the import template",
    "URL Invalide": "Invalid URL",
    "Une erreur est survenue.": "An error occurred.",
    "Utilisateur invalide.": "Invalid user.",
    "Valider le cashout": "Confirm the cashout",
    "Veuillez corriger les champs signalés ci-dessous.": "Please fix the fields flagged below.",
    "Veuillez saisir un montant valide.": "Please enter a valid amount.",
    "Veuillez sélectionner une méthode de paiement.": "Please select a payment method.",
    "Voulez-vous autoriser cet utilisateur à créer du contenu spécial ?": "Do you want to allow this user to create special content?",
    "Voulez-vous bloquer cet utilisateur de créer du contenu spécial ?": "Do you want to block this user from creating special content?",
    "Gérer": "Manage",

    // Administrateurs, rôles, mot de passe oublié
    "Rôles et permissions": "Roles and permissions",
    "Action impossible, veuillez réessayer.": "Action failed, please try again.",
    "Action non autorisée": "Action not allowed",
    "Envoyer un nouveau mot de passe temporaire à {{email}} ? Ses sessions ouvertes seront fermées.": "Send a new temporary password to {{email}}? Their open sessions will be closed.",
    "Mot de passe envoyé par e-mail.": "Password sent by e-mail.",
    "Fermer les sessions ouvertes de {{name}} ?": "Close the open sessions of {{name}}?",
    "Rechercher par nom ou adresse e-mail": "Search by name or e-mail address",
    "Tous les statuts": "All statuses",
    "Actifs": "Active",
    "Inactifs": "Inactive",
    "Tous les rôles": "All roles",
    "Jamais connecté": "Never signed in",
    "{{n}} session(s)": "{{n}} session(s)",
    "Réinitialiser le mot de passe (envoyé par e-mail)": "Reset password (sent by e-mail)",
    "Fermer les sessions ouvertes": "Close open sessions",
    "Aucun compte ne correspond à la recherche.": "No account matches your search.",
    "Rôle (permissions)": "Role (permissions)",
    "Rôle par défaut (selon le type de compte)": "Default role (based on account type)",
    "Laisser vide pour conserver le mot de passe actuel.": "Leave empty to keep the current password.",
    "Laisser vide : un mot de passe temporaire est généré et envoyé par e-mail.": "Leave empty: a temporary password is generated and sent by e-mail.",
    "Si un compte correspond à cette adresse, un lien de réinitialisation vient d'être envoyé.": "If an account matches this address, a reset link has just been sent.",
    "Entrez votre adresse email : si un compte lui correspond, vous recevrez un lien pour choisir un nouveau mot de passe.": "Enter your e-mail address: if an account matches it, you will receive a link to choose a new password.",
    "Trop de demandes. Réessayez dans quelques instants.": "Too many requests. Please try again in a few moments.",
    "Envoi en cours...": "Sending...",
    "Recevoir le lien de réinitialisation": "Receive the reset link",
    "Mot de passe modifié. Vous pouvez maintenant vous connecter.": "Password changed. You can now sign in.",
    "Ce lien est invalide ou a expiré. Faites une nouvelle demande.": "This link is invalid or has expired. Please make a new request.",
    "Trop de tentatives. Réessayez dans quelques instants.": "Too many attempts. Please try again in a few moments.",
    "Une erreur s'est produite. Veuillez réessayer plus tard.": "An error occurred. Please try again later.",
    "Minimum 8 caractères": "Minimum 8 characters",
    "Ce lien est incomplet. Faites une nouvelle demande de réinitialisation.": "This link is incomplete. Please request a new reset.",
    "Demander un nouveau lien": "Request a new link",
    "Enregistrer le mot de passe": "Save password",
    "Supprimer le rôle « {{name}} » ?": "Delete the role “{{name}}”?",
    "Nouveau rôle": "New role",
    "Rôle": "Role",
    "Description": "Description",
    "Modules": "Modules",
    "Comptes": "Accounts",
    "Par défaut": "Default",
    "Modifier le rôle": "Edit role",
    "Modules accessibles": "Accessible modules",
    "Tout cocher / décocher": "Check / uncheck all",
    "Les permissions s'appliquent par module. Le compte root a tous les droits ; la gestion des administrateurs et des rôles lui reste réservée. Modifier un rôle déconnecte ses titulaires, qui retrouvent leur menu à la prochaine connexion.": "Permissions apply per module. The root account has every right; managing administrators and roles stays reserved for it. Editing a role signs out its holders, who get their menu back at their next sign-in.",
    "Général": "General",
    "Communauté": "Community",
    "Modération": "Moderation",
    "Finance": "Finance",
    "Organisation": "Organization",
    "Administration": "Administration",
    "Utilisateurs et pages": "Users and pages",
    "Opinions et boosts": "Opinions and boosts",
    "Événements": "Events",
    "Agoras et lives": "Agoras and lives",
    "Signalements": "Reports",
    "Vérifications": "Verifications",
    "Monétisation (portefeuilles, retraits)": "Monetization (wallets, withdrawals)",
    "Sécurité (hubs, autorisations)": "Security (hubs, authorizations)",
    "Paramètres et parrainage": "Settings and referral",
    "Menu": "Menu",
    "Fermer": "Close",
    "Nouveaux utilisateurs": "New users",
    "Pièces": "Coins",
    "Likes": "Likes",
    "Inconnu": "Unknown",
    "Aucune donnée à afficher.": "No data to display.",
    "Nouveaux utilisateurs et utilisateurs actifs": "New and active users",
    "Par période": "By period",
    "Pays avec le plus d'utilisateurs actifs": "Countries with the most active users",
    "Top 8": "Top 8",
    "Gains des comptes monétisés (USD)": "Earnings of monetized accounts (USD)",
    "Pièces, likes et vues": "Coins, likes and views",
    "Nouveaux utilisateurs {{app}}": "New {{app}} users",
    "Utilisateurs {{app}} actifs": "Active {{app}} users",
    "Top 10 des utilisateurs {{app}} les plus suivis": "Top 10 most followed {{app}} users",
    "Opinions actives": "Active opinions",
    "API de secours et traduction automatique.": "Fallback API and automatic translation.",
    "Application mobile": "Mobile app",
    "Bonus, plafond, budget et alertes.": "Bonuses, cap, budget and alerts.",
    "Conditions pour créer du contenu spécial.": "Requirements to create special content.",
    "Contenu et affichage": "Content and display",
    "Contenu spécial": "Special content",
    "KYC": "KYC",
    "KYC du parrain pour obtenir un code": "Referrer KYC to get a code",
    "KYC pour ajouter / modifier un portefeuille": "KYC to add / edit a wallet",
    "KYC pour les retraits": "KYC for withdrawals",
    "Les bonus sont versés après la vérification de l'e-mail du filleul. Les montants sont en USD et convertis en coins au moment du versement.": "Bonuses are paid once the referred user's e-mail is verified. Amounts are in USD and converted to coins at payout time.",
    "Opérations qui exigent un KYC validé.": "Operations that require a validated KYC.",
    "Pagination, fil « For You » et identité visuelle.": "Pagination, “For You” feed and visual identity.",
    "Récompenses": "Rewards",
    "Récompenses des meilleurs commentaires et suggestions.": "Rewards for top comments and suggestions.",
    "Services externes": "External services",
    "Taux de conversion, retraits et frais.": "Conversion rates, withdrawals and fees.",
    "Versions publiées sur les stores.": "Versions published on the stores.",
    "Vérification d'identité (KYC)": "Identity verification (KYC)",
    "jours": "days",
    "Espace administrateur": "Administrator area",
    "Posts actifs": "Active posts",
    "Utilisateurs par pays": "Users by country",
    "Utilisateurs par badge": "Users by badge",
    "Pays représentés": "Countries represented",
    "Inscriptions récentes": "Recent sign-ups",
    "Pays n°1": "Top country",
    "des utilisateurs actifs": "of active users",
    "Top {{n}}": "Top {{n}}",
    "Pays avec le plus d'utilisateurs récents": "Countries with the most recent users",
    "Nourriture": "Food",
    "Couleurs": "Colors",
    "Travail": "Work",
    "Loisirs": "Hobbies",
    "{{n}} pays avec des inscriptions récentes": "{{n}} countries with recent sign-ups",
    "{{n}} en moyenne par pays": "{{n}} on average per country",
    "{{country}} en tête": "{{country}} leads",
    "Validation d'identité": "Identity validation",
    "Toutes": "All",
    "Validées": "Validated",
    "Refusées": "Refused",
    "Demandes à examiner": "Requests to review",
    "Identités confirmées": "Confirmed identities",
    "Demandes rejetées avec motif": "Requests rejected with a reason",
    "Aucune demande de validation d'identité.": "No identity validation requests.",
    "Examiner": "Review",
    "Consulter": "View",
    "Retrait manuel": "Manual withdrawal",
    "Débitez les pièces, likes, vues et gains de contenus spéciaux d'un utilisateur en échange de la somme équivalente en USD, réglée hors plateforme (virement, espèces, Mobile Money…).": "Debit a user's coins, likes, views and special-content earnings in exchange for the equivalent amount in USD, paid outside the platform (transfer, cash, Mobile Money…).",
    "Utilisateur introuvable.": "User not found.",
    "Impossible de charger les soldes.": "Unable to load balances.",
    "Retrait enregistré": "Withdrawal recorded",
    "référence": "reference",
    "Voir les retraits": "View withdrawals",
    "Total retirable": "Total withdrawable",
    "Équivalent USD de tous les soldes": "USD equivalent of all balances",
    "Retrait en cours de saisie": "Withdrawal being entered",
    "Somme à régler à l'utilisateur": "Amount to pay the user",
    "Saisissez des quantités ci-dessous": "Enter quantities below",
    "Ce qui est retiré": "What is withdrawn",
    "Tout retirer": "Withdraw everything",
    "Source": "Source",
    "Disponible": "Available",
    "Valeur unitaire": "Unit value",
    "À retirer": "To withdraw",
    "Équivalent USD": "USD equivalent",
    "Max": "Max",
    "Dépasse le solde disponible": "Exceeds the available balance",
    "Somme équivalente à régler": "Equivalent amount to pay",
    "Référence du règlement": "Payment reference",
    "N° de virement, de reçu, de transaction Mobile Money…": "Transfer, receipt or Mobile Money transaction no.",
    "Note (facultatif)": "Note (optional)",
    "Effectuer le retrait": "Make the withdrawal",
    "Confirmer le retrait": "Confirm the withdrawal",
    "Retrait pour": "Withdrawal for",
    "Je confirme que {{amount}} a été ou sera réglé à l'utilisateur. Les soldes seront débités et cette action est définitive.": "I confirm that {{amount}} has been or will be paid to the user. The balances will be debited and this action is final.",
    "Contenus spéciaux": "Special content",
    "Non configurée": "Not configured",
    "Laisser vide pour conserver la clé actuelle": "Leave empty to keep the current key",
    "Coller la clé API": "Paste the API key",
    "Supprimer la clé enregistrée": "Delete the saved key",
    "L'utilisateur a été notifié (application et push).": "The user has been notified (in-app and push).",
    "Le retrait est enregistré, mais la notification n'a pas pu être envoyée.": "The withdrawal is recorded, but the notification could not be sent.",
    // Fiche modérateur et menu Actions
    "Actions": "Actions",
    "Voir le détail": "View details",
    "Désactiver": "Deactivate",
    "Activer": "Activate",
    "Réinitialiser le mot de passe": "Reset password",
    "Détail du modérateur": "Moderator details",
    "Compte introuvable.": "Account not found.",
    "Erreur de chargement.": "Loading error.",
    "Votre propre compte se gère depuis votre profil.": "Manage your own account from your profile.",
    "Un compte root ne peut pas être modifié, désactivé ni supprimé.": "A root account cannot be edited, deactivated or deleted.",
    "Accès": "Access",
    "Type de compte": "Account type",
    "Tous les droits": "All permissions",
    "Permissions": "Permissions",
    "Section": "Section",
    "Dernière connexion": "Last login",
    "Sessions ouvertes": "Open sessions",
    "Créé le": "Created on",
    "Modifié le": "Updated on",
    "Dernières actions": "Recent actions",
    "Aucune action enregistrée.": "No recorded action.",
    // Signalements
    "Validés": "Approved",
    "Rejetés": "Rejected",
    "Reçus aujourd'hui": "Received today",
    "Contenus les plus signalés (en attente)": "Most reported content (pending)",
    "Contenu supprimé": "Deleted content",
    "Rechercher : texte, auteur ou signaleur": "Search: text, author or reporter",
    "Tous les contenus": "All content",
    "Tous les motifs": "All reasons",
    "Du": "From",
    "Au": "To",
    "Effacer les filtres": "Clear filters",
    "Date": "Date",
    "Contenu signalé": "Reported content",
    "Auteur": "Author",
    "Signalé par": "Reported by",
    "Motifs": "Reasons",
    "Aucun signalement ne correspond aux filtres.": "No report matches the filters.",
    "Voir la fiche": "View details",
    "Valider le signalement": "Approve report",
    "Rejeter le signalement": "Reject report",
    "{{n}} signalement(s)": "{{n}} report(s)",
    "Validé": "Approved",
    "Commentaire": "Comment",
    "Opinion": "Opinion",
    "Compte supprimé": "Deleted account",
    "bloqué": "blocked",
    "Valider ce signalement ? Le signaleur sera prévenu par e-mail.": "Approve this report? The reporter will be notified by email.",
    "Rejeter ce signalement ? Le signaleur sera prévenu par e-mail.": "Reject this report? The reporter will be notified by email.",
    "Fiche du signalement": "Report details",
    "{{n}} signalement(s) sur ce contenu": "{{n}} report(s) on this content",
    "(sans texte)": "(no text)",
    "Contenu supprimé depuis le signalement.": "Content deleted since the report.",
    "Opinion commentée": "Commented opinion",
    "Valider": "Approve",
    "Rejeter": "Reject",
    "Historique des signalements de ce contenu": "Report history for this content",
    "À traiter": "To review",
    "Signalements confirmés": "Confirmed reports",
    "Signalements non fondés": "Unfounded reports",
    "Tous statuts : {{n}}": "All statuses: {{n}}",
    "Compte signalé": "Reported account",
    "Compte signalé depuis une conversation privée.": "Account reported from a private conversation.",
    "Pièces jointes": "Attachments",
    // Opinions
    "Posts publiés": "Published posts",
    "Opinions publiées": "Published opinions",
    "{{n}} sur 7 jours · {{d}} aujourd'hui": "{{n}} in 7 days · {{d}} today",
    "Avec médias": "With media",
    "{{p}} % du total · {{v}} vidéo(s)": "{{p}}% of total · {{v}} video(s)",
    "Signalées": "Reported",
    "{{m}} rendue(s) muette(s)": "{{m}} muted",
    "Boostées en cours": "Active boosts",
    "{{n}} privée(s)": "{{n}} private",
    "Boostées": "Boosted",
    "Mot clé dans le texte": "Keyword in text",
    "Auteur (nom d'utilisateur)": "Author (username)",
    "Tous les types": "All types",
    "Texte seul": "Text only",
    "Images": "Images",
    "Vidéos": "Videos",
    "Audios": "Audios",
    "Toutes les visibilités": "All visibilities",
    "Publiques": "Public",
    "Privées": "Private",
    "Toutes (modération)": "All (moderation)",
    "Rendues muettes": "Muted",
    "Plus récentes": "Most recent",
    "Plus soutenues": "Most supported",
    "Plus commentées": "Most commented",
    "Plus signalées": "Most reported",
    "{{n}} résultat(s)": "{{n}} result(s)",
    "Aucune opinion ne correspond aux filtres.": "No opinion matches the filters.",
    "Muette": "Muted",
    "Boostée": "Boosted",
    "Rétablir l'opinion": "Unmute opinion",
    "Rendre muette": "Mute opinion",
    "Rétablir l'auteur": "Unmute author",
    "Rendre l'auteur muet": "Mute author",
    "Booster": "Boost",
    "Retirer le boost": "Remove boost",
    "Voir le post": "View post",
    "Voir l'opinion": "View opinion",
    // Utilisateurs
    "Inscrits": "Registered",
    "+{{w}} en 7 jours · +{{m}} en 30 jours": "+{{w}} in 7 days · +{{m}} in 30 days",
    "Certifiés": "Verified",
    "{{p}} % des comptes": "{{p}}% of accounts",
    "Gold": "Gold",
    "Bloqués": "Blocked",
    "{{m}} rendu(s) muet(s)": "{{m}} muted",
    "Rechercher…": "Search…",
    "Non certifiés": "Not verified",
    "Rendus muets": "Muted",
    "Contacts": "Contacts",
    "Abonnés": "Followers",
    "Fans": "Fans",
    "Fan de": "Fan of",
    "Réactions": "Reactions",
    "Certifié": "Verified",
    "Bloqué": "Blocked",
    "Muet": "Muted",
    "pièces": "coins",
    "likes": "likes",
    "vues": "views",
    // Fiche utilisateur
    "Inscrit le {{d}}": "Joined on {{d}}",
    "Restreint jusqu'au {{d}}": "Restricted until {{d}}",
    "Muet jusqu'au {{d}}": "Muted until {{d}}",
    "Contenu spécial autorisé": "Special content allowed",
    "Rétablir la parole": "Unmute",
    "Rendre muet": "Mute",
    "Bloquer le contenu spécial": "Block special content",
    "Autoriser le contenu spécial": "Allow special content",
    "Offrir": "Offer",
    "Un abonnement": "A subscription",
    "Des coins": "Coins",
    "{{c}} commentaire(s) · {{a}} agora(s)": "{{c}} comment(s) · {{a}} agora(s)",
    "Réactions reçues": "Reactions received",
    "Soutiens reçus sur ses opinions": "Supports received on their opinions",
    "{{l}} likes · {{v}} vues": "{{l}} likes · {{v}} views",
    "{{p}} {{pl}} · suit {{s}} compte(s)": "{{p}} {{pl}} · follows {{s}} account(s)",
    "contacts": "contacts",
    "potes": "buddies",
    "Souscriptions": "Subscriptions",
    // Agoras et lives
    "Créée le {{d}}": "Created on {{d}}",
    "membre(s)": "member(s)",
    "post(s)": "post(s)",
    "opinion(s)": "opinion(s)",
    "+{{n}} créée(s) en 30 jours": "+{{n}} created in 30 days",
    "Actives (30 jours)": "Active (30 days)",
    "{{n}} publication(s) en 30 jours": "{{n}} post(s) in 30 days",
    "Adhésions": "Memberships",
    "{{n}} membre(s) distinct(s)": "{{n}} distinct member(s)",
    "Sans membre": "No members",
    "{{p}} % du total": "{{p}}% of total",
    "Titre ou présentation": "Title or description",
    "Toutes les agoras": "All agoras",
    "Sans activité (30 jours)": "No activity (30 days)",
    "Plus de membres": "Most members",
    "Plus de publications": "Most posts",
    "Plus anciennes": "Oldest",
    "Aucune agora ne correspond aux filtres.": "No agora matches the filters.",
    "Lives en cours": "Live streams",
    "Impossible d'arrêter le live, veuillez réessayer.": "Could not stop the live, please try again.",
    "En direct": "Live",
    "{{n}} en pause": "{{n}} paused",
    "Durée moyenne": "Average duration",
    "Plus long : {{d}}": "Longest: {{d}}",
    "Aucun live": "No live",
    "Abonnés aux lives": "Live subscribers",
    "Somme des abonnés des lives en cours": "Total subscribers of current lives",
    "Accès restreint": "Restricted access",
    "Privés, contenu spécial ou +18": "Private, special content or 18+",
    "Rechercher : animateur ou description": "Search: host or description",
    "Tous les lives": "All lives",
    "En pause": "Paused",
    "Audience privée": "Private audience",
    "Mise à jour en temps réel · {{n}} live(s) affiché(s)": "Real-time updates · {{n}} live(s) shown",
    "Aucun live ne correspond aux filtres.": "No live matches the filters.",
    "Depuis le {{d}}": "Since {{d}}",
    "Privé": "Private",
    "Commentaires bloqués": "Comments blocked",
    "{{n}} abonné(s)": "{{n}} subscriber(s)",
    "Arrêt…": "Stopping…",
    "Arrêter le live": "Stop live",
    "Balance totale : pièces, likes et vues non payés aux taux des Paramètres, plus les contenus spéciaux": "Total balance: unpaid coins, likes and views at the Settings rates, plus special content",
};
